export const DEFAULT_LIGHTNING_REASON = ({ definitionName }) =>
  `This SQL snippet creates a dedicated ${definitionName} user for Hightouch. It also provisions two schemas (\`hightouch_planner\` and \`hightouch_audit\`) for storing logs of previously-synced data.`;

export const DEFAULT_LIGHTNING_CODE_TITLE = () => "Set up a service user to write to your instance";
